import cn from 'classnames'
import React, { useCallback } from 'react'

import { TooltipCourse } from 'components/Editor/EditorElements/courseKit/DropDownCourse'
import ScreenReaderOnlyText from 'components/Editor/styled/ScreenReaderOnlyText'
import Icon from 'components/uiKit/Icon'
import { questionValidate } from 'services/Store/Project/actions'
import { useProjectContext, useProjectDispatch } from 'services/Store/Project/hooks'
import { getBlockId, getBlockState, getBlock, getSectionId } from 'services/Store/Project/selectors'
import { getTestNextTrigger } from 'services/Store/Project/triggers'
import { t } from 'services/Translation'

import { useAccessibleTimer } from '../useTestTimer'
import * as s from './BlockTestTimer.module.scss'

const BlockTestTimer: React.FC = () => {
  const dispatch = useProjectDispatch()
  const time = useProjectContext(getBlock)?.test?.time || 0
  const startTime = useProjectContext(getBlockState)?.startTime
  const sectionId = useProjectContext(getSectionId)
  const trigger = useProjectContext(getTestNextTrigger, { currentSectionId: sectionId })
  const blockId = useProjectContext(getBlockId) || ''

  const onFinish = useCallback(() => {
    dispatch(questionValidate({ blockId }))
    if (!trigger.disabled) {
      dispatch(trigger.actionCreator())
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, blockId])

  const { isFire, left, srMessage } = useAccessibleTimer({
    startTime,
    time,
    stop: !startTime,
    onFinish,
  })

  return (
    <TooltipCourse overlay={t('elements.testFooter.tooltip.timeBlock')}>
      <div className={cn(s.root, { [s.fireTime]: isFire })}>
        <Icon className={s.icon} name={isFire ? 'statusDeadline20Px' : 'otherClock'} />
        <time>{left}</time>
        <div aria-atomic='true' aria-live='polite'>
          <ScreenReaderOnlyText>{srMessage}</ScreenReaderOnlyText>
        </div>
      </div>
    </TooltipCourse>
  )
}

export default BlockTestTimer
